import React, { useState } from "react";
import { default as ReactSelect } from "react-select";
import { Option } from "../../shared/components/_commons/Option";
import {
  faBriefcase,
  faFilter,
  faMagnifyingGlass,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, FormGroup, Input, Row } from "reactstrap";
import { customStyles } from "./application-custom-selector-styles";
import { IProvince } from "../../shared/model/province.model";
import { IFilterApplication } from "./application-filter-interface";
import { provinceById } from "../../shared/selectors/provinceOptions";
import { initialStateFilter } from "./Home";
import { ValueContainer } from "../../shared/components/_commons/ValueContainer";

interface IProps {
  handleSubmit: (e: React.FormEvent) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  provinces: Readonly<IProvince[]>;
  setFilterData: (data: IFilterApplication) => void;
  filterData: IFilterApplication;
}

function sortProvinces(current, next) {
  return current.label.localeCompare(next.label);
}

const ApplicationFilter = (props: IProps) => {
  const { handleSubmit, handleInputChange, setFilterData, filterData } = props;
  const [selectorOpenMenuStyle, setSelectorOpenMenuStyle] =
    useState("input-custom");
  const onMenuOpen = () => setSelectorOpenMenuStyle("input-custom-active");
  const onMenuClose = () => setSelectorOpenMenuStyle("input-custom");
  const provincesOptions = (provinces: IProvince[] | any): [] => {
    const options: [] = provinces
      ? provinces.map((p: IProvince) => ({
          value: p.id,
          label: p.name,
        }))
      : null;
    options.sort(sortProvinces);
    return options;
  };
  return (
    <div className="mt-5 container-form-filter">
      <Form
        className="filter-bar bg-white"
        id="form-filter"
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <div className="filter-bar-inside-container">
          <div className="container-job">
            <FormGroup className="d-flex m-3 align-items-center">
              <FontAwesomeIcon
                icon={faBriefcase}
                className={`${filterData.name !== "" ? "icon-green" : ""}`}
              />
              <Input
                className="border border-white input-custom container-select-job"
                placeholder="Cargo o categoría"
                name="name"
                value={filterData.name}
                onChange={handleInputChange}
                width="100%"
              />
            </FormGroup>
          </div>

          <div className="container-select-province">
            <FormGroup className="d-flex m-3 align-items-center container-select-province-inside">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className={`icon-react-select ${
                  filterData.provinces.length > 0 ? "icon-green" : ""
                }`}
              />
              {
                <ReactSelect
                  className={selectorOpenMenuStyle}
                  onMenuOpen={onMenuOpen}
                  onMenuClose={onMenuClose}
                  options={provincesOptions(props.provinces)}
                  isMulti
                  hideSelectedOptions={false}
                  value={provinceById(props.provinces, filterData.provinces)}
                  components={
                    filterData.provinces.length > 1
                      ? { Option, ValueContainer }
                      : { Option }
                  }
                  onChange={(e) => {
                    const provinces = e.map(
                      (currentValue) => currentValue.value
                    );
                    setFilterData({
                      ...filterData,
                      provinces,
                    });
                  }}
                  noOptionsMessage={() => "No se encontraron resultados"}
                  styles={customStyles}
                  placeholder="Provincias"
                />
              }
            </FormGroup>
          </div>
          <div className="container-filter-btn">
            <Button className="btn-portal-filter btn-portal-search">
              <FontAwesomeIcon icon={faMagnifyingGlass} />
              Buscar
            </Button>
            {/*
              (filterData.name !== "" || filterData.provinces.length > 0) && (
                <Button
                  className="btn-portal-filter portal-clean-btn m-3"
                  onClick={(e) => {
                    setFilterData(initialStateFilter);
                  }}
                >
                  X
                </Button>
              )}
                */}
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ApplicationFilter;
